import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ServicesRatesService } from '../../../services/servicesRatesService';
import { ServiceRate } from '../../../models/ServiceRate';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-update-rate-category',
  templateUrl: './update-rate-category.component.html',
  styleUrls: ['./update-rate-category.component.scss'],
})
export class UpdateRateCategoryComponent implements OnInit {
  serviceId: number;
  serviceRate: ServiceRate;
  constructor(private diagRef: NbDialogRef<UpdateRateCategoryComponent>,
     private route : Router,
      private service: ServicesRatesService) {
    this.serviceRate = {} as ServiceRate;
    this.serviceRate.serviceId = this.serviceId;
  }

  ngOnInit(): void {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
  }

  add() {
    // this.serviceRate.serviceId = this.serviceId;
    this.service.put(this.serviceRate.id, this.serviceRate).subscribe((res) => {
      this.diagRef.close('true');
    });
  }
}
